const warn = msg => {
  // eslint-disable-next-line no-console
  console.warn(`[@xo-union/tk-component-picture]: ${msg}`);
};

export default warn;